import React from "react";
import { useFormContext } from "react-hook-form";
import { useQuery } from "react-query";
import { getPropertyFloodRisk } from "../../../api/geocode.api";
import { ClimateRiskType } from "../../../types/appraiser.types";
import { useTranslation } from "react-i18next";
import { getPropertyFloodRiskLabel } from "./otherFields.helpers";
import { FormInputSuggestion } from "../../../components/form/FormInputSuggestion";
import { FormFieldWrapper } from "common/components/form/FormFieldWrapper";
import { FloodZoneCriteria } from "../../property/FloodZoneCriteria";

export const FloodRiskField: React.FC = () => {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext();

  const lat = watch("lat");
  const lng = watch("lng");

  const { isLoading, data } = useQuery(
    ["property_flood_risk", lat, lng],
    () => getPropertyFloodRisk(lat, lng),
    {
      enabled: !!lat && !!lng,
      staleTime: 0,
    }
  );

  const currentValue = watch("floodRisk") as ClimateRiskType | null | undefined;
  const address = watch("address");

  return (
    <>
      <FormFieldWrapper label={t("propertyForm.floodRisk")}>
        <FloodZoneCriteria
          floodRisk={currentValue}
          disabled={isLoading}
          onChange={(value) =>
            setValue("floodRisk", value, { shouldDirty: true })
          }
        />
      </FormFieldWrapper>
      <FormInputSuggestion
        suggestionLabel={
          data?.floodRisk ? getPropertyFloodRiskLabel(data.floodRisk) ?? "" : ""
        }
        currentValue={currentValue}
        suggestedValue={data?.floodRisk}
        onAgree={(value) => setValue("floodRisk", value, { shouldDirty: true })}
        address={address}
        source="ArcGisFlood"
      />
    </>
  );
};
